import { useSubscription } from "@apollo/client";
import React from "react";
import { Redirect, Route } from "react-router-dom";
import { Loader } from "../../Components/Loader";
import { GET_USER_DETAILS_BY_ID } from "../../Graphql/subscriptions";

export const PrivateRoutes = ({
  template: Template,
  PageContent,
  lastScreen,
  SubTemplate,
  ...rest
}) => {
  const { data: userData, loading: isUserDataLoading } = useSubscription(
    GET_USER_DETAILS_BY_ID,
    {
      variables: { user_id: localStorage.getItem("user_id") },
      fetchPolicy: "cache-and-network",
      skip: !localStorage.user_id || !localStorage.sanattest_access_token,
    }
  );
  return (
    <Route
      {...rest}
      render={(props) => {
        if (!localStorage.user_id || !localStorage.sanattest_access_token) {
          localStorage.clear()
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{ pathname: "/welcome", state: { from: props.location } }}
            />
          );
        }
        //Onboarding Complete so redirect to dashboard
        if (!!lastScreen && lastScreen === "/") {
          return <Redirect to={{ pathname: "/" }} />;
        }
        if (isUserDataLoading) {
          return <Loader />;
        }
        // authorised so return component
        return (
          <Template {...rest} {...props} userData={userData}>
            {SubTemplate ? (
              <SubTemplate {...rest} {...props} userData={userData}>
                <PageContent {...rest} {...props} userData={userData} />
              </SubTemplate>
            ) : (
              <PageContent {...rest} {...props} userData={userData} />
            )}
          </Template>
        );
      }}
    />
  );
};
